var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bank-cards-get',{attrs:{"params":{
        with_unverified: false
    }},on:{"success":_vm.onSuccess},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var cards = ref.data;
    var meta = ref.meta;
    var is_loading = ref.is_loading;
return [(is_loading)?_c('div',{staticClass:"opacity-50 input is-disabled"},[_c('div',{staticClass:"py-px leading-none"},[_vm._v("\n            Loading...\n        ")])]):(meta.count === 0)?_c('router-link',{staticClass:"btn btn-blue-lightest",attrs:{"to":{
            name: _vm.$router.fix('dashboard.*.bank-cards.create')
        }}},[_vm._v("\n        Add a bank card\n    ")]):_c('input-select',{attrs:{"value":_vm.value,"sid":_vm.sid,"name":_vm.name,"disabled":_vm.disabled,"options":_vm.transform(cards),"placeholder":"Select a bank card..."},on:{"input":function($event){return _vm.$emit('input', arguments[0])}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }